module.exports = __webpack_public_path__ + "img/header2x.6b64d3aa.jpg";